import { createTheme } from '@mantine/core';

export const theme = createTheme({
  primaryColor: 'brand',
  fontFamily: 'Inter, sans-serif',
  headings: {
    fontFamily: 'Inter, sans-serif'
  },
  fontSizes: {
    xs: "0.75rem",  // 10.5px
    sm: "0.85rem",  // 11.9px
    md: "1rem",     // 14px :: default
    lg: "1.25rem",  // 17.5px
    xl: "1.5rem",   // 21px
    "2xl": "2rem",  // 28px
  },
  colors: {
    // v7 expects exactly 10 shades per color
    brand: [
      '#e6e6ff', '#b5b6ff', '#8686f9', '#5656f6', '#2725f2',
      '#100dd9', '#0909a9', '#05077a', '#01034c', '#00001e',
    ]
  },
  // We place your specific component defaultProps here
  components: {
    Container: {
      defaultProps: {
        sizes: { xs: 540, sm: 720, md: 960, lg: 1140, xl: 1440 },
      }
    },
    Anchor: {
      styles: { root: { fontSize: 14 } }
    },
    Menu: {
      styles: { item: { fontSize: 14 } }
    },
    TextInput: {
      styles: { input: { fontSize: 14 } }
    },
    NumberInput: {
      styles: { input: { fontSize: 14 } }
    },
    DatePicker: {
      styles: { input: { fontSize: 14 } }
    }
  }
});